<template>
  <div>
    <section v-if="cntCartItems" class="section section-aside">
      <div class="section-aside__container" data-sticky>
        <div class="section-aside__cont">
          <form class="form order-form">
            <div class="order-form__item">
              <fieldset class="form-group">
                <legend class="form-group__label">{{ cartCheckoutDetails }}</legend>
                <div class="form__items form__items--2">
                  <div class="form__item form__item--all">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.fio.value" class="default-input__input" type="text" :placeholder="cartCheckoutName +' *'" required>
                        <label class="default-input__label">{{ cartCheckoutName }} *</label>
                      </div>
                    </div>
                  </div>
                  <div class="form__item">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.email.value" class="default-input__input" type="email" placeholder="E-mail" required>
                        <label class="default-input__label">E-mail *</label>
                      </div>
                      <div class="default-input__error"><span>{{ cartCheckoutError }}</span></div>
                    </div>
                  </div>
                  <div class="form__item">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.phone.value" class="default-input__input" type="tel" inputmode="numeric" :placeholder="cartCheckoutPhone + ' *'" data-input-mask="phone">
                        <label class="default-input__label">{{ cartCheckoutPhone }} *</label>
                      </div>
                      <div class="default-input__error"><span>{{ cartCheckoutError }}</span></div>
                    </div>
                  </div>
                  <div class="form__item form__item--all">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.companyName.value" class="default-input__input" type="text" :placeholder="cartCheckoutCompany + ' *'" required>
                        <label class="default-input__label">{{ cartCheckoutCompany }} *</label>
                      </div>
                    </div>
                  </div>
                  <div class="form__item">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.jobTitle.value" class="default-input__input" type="text" :placeholder="cartCheckoutJob + ' *'" required>
                        <label class="default-input__label">{{ cartCheckoutJob }} *</label>
                      </div>
                    </div>
                  </div>
                  <div class="form__item">
                    <div class="default-input">
                      <div class="default-input__body" data-sticky-label>
                        <input v-model="personalData.companySite.value" class="default-input__input" type="text" :placeholder="cartCheckoutSite">
                        <label class="default-input__label">{{ cartCheckoutSite }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset class="form-group">
                <legend class="form-group__label">{{ cartCheckoutShipping }}</legend>
                <div class="form-group__radios form-group__radios--2 form-group__radios--delivery">
                  <div v-for="shippingMethod in shippingMethods" :key="shippingMethod.id" class="form-group__radios-item">
                    <div class="default-radio">
                      <input v-model="selectedShippingMethod" :value="shippingMethod.code" class="default-radio__input" type="radio" :id="'shippingMethod-'+shippingMethod.id">
                      <label class="default-radio__label" :for="'shippingMethod-'+shippingMethod.id"><span class="default-radio__name">{{ shippingMethod.name }}</span></label>
                    </div>
                  </div>
                  <div v-if="selectedShippingMethod === 'pickup'" class="form-group__radios-fieldset form-group__radios-fieldset--left">
                    <div class="form-info">
                      <div class="form-info__item">
                        <div class="form-info__item-label">{{ cartCheckoutShippingText }}</div>
                        <div class="form-info__item-text">{{ cartCheckoutShippingAddress }}</div>
                        <a class="icon-link icon-link--base" href="https://yandex.ru/maps/-/CCUcVNcdKD" target="_blank">
                          <span>{{ cartCheckoutMap }}</span>
                          <svg class="icon-link__icon" aria-hidden="true">
                            <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div v-if="selectedShippingMethod === 'delivery'" class="form-group__radios-fieldset form-group__radios-fieldset--right">
                    <div class="form-group__label">{{ cartCheckoutAddress }}</div>
                    <div class="form__items form__items--delivery">
                      <div class="form__item form__item--all">
                        <div class="default-select">
                          <div class="default-select__body">
                            <!--select v-model="deliveryData.city.value" class="default-select__select" data-placeholder="Город" required data-search>
                                <option data-placeholder="true"></option>
                                <option v-for="city in cities" :key="city.cityId" :value="city.cityCode">{{ city.cityName }}</option>
                            </select>
                            <label class="default-select__label">Город *</label>
                            <div class="default-select__dropdown" id="slim-dropdown"></div-->
                            <city-select v-model="deliveryData.city.value"></city-select>
                          </div>
                        </div>
                      </div>
                      <div class="form__item form__item--all">
                        <div class="default-input">
                          <div class="default-input__body" data-sticky-label>
                            <input v-model="deliveryData.street.value" class="default-input__input" type="text" :placeholder="cartCheckoutStreet" required>
                            <label class="default-input__label">{{ cartCheckoutStreet }} *</label>
                          </div>
                        </div>
                      </div>
                      <div class="form__item">
                        <div class="default-input">
                          <div class="default-input__body" data-sticky-label>
                            <input v-model="deliveryData.house.value" class="default-input__input" type="text" :placeholder="cartCheckoutHouse" required>
                            <label class="default-input__label">{{ cartCheckoutHouse }} *</label>
                          </div>
                        </div>
                      </div>
                      <div class="form__item form__item--3">
                        <InputDate v-model="deliveryData.date.value" :min="deliveryDateCalc()" :placeholder="cartCheckoutDate"/>
                        <!--                                                <div class="default-input input-date" date-calendar-min="2023-03-22">-->
                        <!--                                                    <div class="default-input__body" data-sticky-label>-->
                        <!--                                                        <input v-model="deliveryData.date.value" class="default-input__input input-date__input" type="text" placeholder="Ожидаемая дата доставки">-->
                        <!--                                                        <label class="default-input__label">Ожидаемая дата доставки</label>-->
                        <!--                                                    </div>-->
                        <!--                                                    <div class="calendar-popup visually-hidden"></div>-->
                        <!--                                                </div>-->
                      </div>
                      <div class="form__item form__item--all">
                        <div class="default-textarea">
                          <div class="default-textarea__body" data-sticky-label>
                            <textarea v-model="deliveryData.comment.value" class="default-textarea__textarea" :placeholder="cartCheckoutComment" rows="1"></textarea>
                            <label class="default-textarea__label">{{ cartCheckoutComment }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </form>
        </div>
        <div class="section-aside__aside section-aside__aside--sticky sticky-el">
          <div class="order-card">
            <div class="order-card__order">
              <div class="order-card__order-label">{{ cartAsideLabel }}</div>
              <div class="order-card__order-value">{{ cntCartItems }} {{ numWords(cntCartItems, [declension1, declension2, declension3]) }}</div>
            </div>
            <div class="order-card__bottom">
              <div class="order-card__accept">
                {{ cartAgreement1 }} <a :href="agreement" target="_blank">{{ cartAgreement2 }}</a>
                {{ cartPolicy1 }} <a :href="policy" target="_blank">{{ cartPolicy2 }}</a>
              </div>
              <div class="order-card__btns">
                <button @click="orderSend()" :class="{'disabled': !isFormValid}" type="button" class="default-btn default-btn--green">
                  {{ cartSend }}
                  <svg class="default-btn__icon" aria-hidden="true">
                    <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-link"></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else class="section section-cart">
      <div class="section-cart__container">
        <div class="section-cart__empty">
          <div class="section-cart__empty-cont">
            <div class="section-cart__empty-title">{{ cartEmptyTitle }}</div>
            <div class="section-cart__empty-links">
              <a class="icon-link icon-link--base" :href="siteDir + 'catalog/stock/'">
                {{ cartEmptyTitle2 }}
                <svg class="icon-link__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
              <a class="icon-link icon-link--base" :href="siteDir + 'catalog/'">
                {{ cartEmptyTitle3 }}
                <svg class="icon-link__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
              <a class="icon-link icon-link--base" :href="siteDir + 'catalog/individual-packing/'">
                {{ cartEmptyTitle4 }}
                <svg class="icon-link__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
            </div>
            <div class="section-cart__empty-btns">
              <a class="default-btn default-btn--green" :href="siteDir">
                {{ cartToMainPage }}
                <svg class="default-btn__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="popup popup--confirm" id="order-confirm">
      <div class="popup__container">
        <div class="popup__title">{{ cartConfirmTitle1 }} <br> {{ cartConfirmTitle2 }}</div>
        <div class="order-confirm">
          <div class="order-confirm__card">
            <div class="order-confirm__card-top">
              <span class="order-confirm__card-title">{{ cartConfirmTitle3 }}</span>
              <span class="order-confirm__card-value">{{ cntCartItems }} {{ numWords(cntCartItems, [declension1, declension2, declension3]) }}</span>
            </div>
            <div class="order-confirm__card-cont">
              <div v-for="(items, group) in groupedItems" :key="group" class="order-confirm__card-item">
                <span class="order-confirm__card-label">{{ group }}</span>
                <div class="order-confirm__card-list">
                  <span class="order-confirm__card-el" v-for="item in items" :key="item.id">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="order-confirm__cont">
            <div class="order-confirm__text">
              <p>{{ cartConfirmTitle4 }} <br> {{ cartConfirmTitle5 }} <br> {{ cartConfirmTitle6 }}</p>
            </div>
            <div class="order-confirm__btns">
              <a class="default-btn default-btn--green" :href="siteDir">
                {{ cartToMainPage }}
                <svg class="default-btn__icon" aria-hidden="true">
                  <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import CitySelect from "@/components/utils/selects/CitySelect.vue";
import InputDate from "@/components/utils/formElements/InputDate.vue";
import Inputmask from "inputmask";

export default {
  name: "CartCheckout",
  components: {
    InputDate,
    CitySelect
  },
  data() {
    return {
      personalData: {
        fio: {
          value: '',
          pattern: /.+/,///^[а-яА-ЯёЁa-zA-Z]{2,100}$/,
        },
        email: {
          value: '',
          pattern: /^\S+@\S+\.\S+$/,
        },
        phone: {
          value: '',
          pattern: /\+[0-9]\s?\([0-9]{3}\)\s?[0-9]{3}\s-\s?[0-9]{2}\s-\s?[0-9]{2}/,
        },
        companyName: {
          value: '',
          pattern: /.+/,
        },
        companySite: {
          value: '',
          pattern: false,
        },
        jobTitle: {
          value: '',
          pattern: /.+/,
        },
      },
      deliveryData: {
        city: {
          value: '',
          pattern: /.+/,
        },
        street: {
          value: '',
          pattern: /.+/,
        },
        house: {
          value: '',
          pattern: /.+/,
        },
        date: {
          value: '',
          pattern: false,
        },
        comment: {
          value: '',
          pattern: false,
        },
      },
      selectedShippingMethod: 'pickup',
      shippingMethods: [
        {
          id: 1,
          code: 'pickup',
          name: BX.message('CART_CHECKOUT_PICKUP'),
        },
        {
          id: 2,
          code: 'delivery',
          name: BX.message('CART_CHECKOUT_DELIVERY'),
        }
      ],
      cities: [],
    };
  },
  props: {
    agreement: String,
    policy: String,
    siteDir: {
      type: [String],
      default: '/'
    },
    cartCheckoutDetails: {
      type: [String],
      default: BX.message('CART_CHECKOUT_DETAILS')
    },
    cartCheckoutName: {
      type: [String],
      default: BX.message('CART_CHECKOUT_NAME')
    },
    cartCheckoutPhone: {
      type: [String],
      default: BX.message('CART_CHECKOUT_PHONE')
    },
    cartCheckoutCompany: {
      type: [String],
      default: BX.message('CART_CHECKOUT_COMPANY')
    },
    cartCheckoutJob: {
      type: [String],
      default: BX.message('CART_CHECKOUT_JOB')
    },
    cartCheckoutSite: {
      type: [String],
      default: BX.message('CART_CHECKOUT_SITE')
    },
    cartCheckoutError: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ERROR')
    },
    cartCheckoutShipping: {
      type: [String],
      default: BX.message('CART_CHECKOUT_SHIPPING')
    },
    cartCheckoutShippingText: {
      type: [String],
      default: BX.message('CART_CHECKOUT_SHIPPING_TEXT')
    },
    cartCheckoutShippingAddress: {
      type: [String],
      default: BX.message('CART_CHECKOUT_SHIPPING_ADDRESS')
    },
    cartCheckoutMap: {
      type: [String],
      default: BX.message('CART_CHECKOUT_MAP')
    },
    cartCheckoutAddress: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ADDRESS')
    },
    cartCheckoutCity: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CITY')
    },
    cartCheckoutStreet: {
      type: [String],
      default: BX.message('CART_CHECKOUT_STREET')
    },
    cartCheckoutHouse: {
      type: [String],
      default: BX.message('CART_CHECKOUT_HOUSE')
    },
    cartCheckoutDate: {
      type: [String],
      default: BX.message('CART_CHECKOUT_DATE')
    },
    cartCheckoutComment: {
      type: [String],
      default: BX.message('CART_CHECKOUT_COMMENT')
    },
    cartCheckoutPickup: {
      type: [String],
      default: BX.message('CART_CHECKOUT_PICKUP')
    },
    cartCheckoutBack: {
      type: [String],
      default: BX.message('CART_CHECKOUT_DELIVERY')
    },
    declension1: {
      type: [String],
      default: BX.message('CART_DECLENSION_1')
    },
    declension2: {
      type: [String],
      default: BX.message('CART_DECLENSION_2')
    },
    declension3: {
      type: [String],
      default: BX.message('CART_DECLENSION_3')
    },
    cartAsideLabel: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ASIDE_LABEL')
    },
    cartAgreement1: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ASIDE_AGREEMENT_1')
    },
    cartAgreement2: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ASIDE_AGREEMENT_2')
    },
    cartPolicy1: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ASIDE_POLICY_1')
    },
    cartPolicy2: {
      type: [String],
      default: BX.message('CART_CHECKOUT_ASIDE_POLICY_2')
    },
    cartSend: {
      type: [String],
      default: BX.message('CART_CHECKOUT_SEND')
    },
    cartEmptyTitle: {
      type: [String],
      default: BX.message('CART_CHECKOUT_EMPTY_TITLE')
    },
    cartEmptyTitle2: {
      type: [String],
      default: BX.message('CART_CHECKOUT_EMPTY_TITLE_2')
    },
    cartEmptyTitle3: {
      type: [String],
      default: BX.message('CART_CHECKOUT_EMPTY_TITLE_3')
    },
    cartEmptyTitle4: {
      type: [String],
      default: BX.message('CART_CHECKOUT_EMPTY_TITLE_4')
    },
    cartEmptyTitle5: {
      type: [String],
      default: BX.message('CART_CHECKOUT_EMPTY_TITLE_5')
    },
    cartConfirmTitle1: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_1')
    },
    cartConfirmTitle2: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_2')
    },
    cartConfirmTitle3: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_3')
    },
    cartConfirmTitle4: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_4')
    },
    cartConfirmTitle5: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_5')
    },
    cartConfirmTitle6: {
      type: [String],
      default: BX.message('CART_CHECKOUT_CONFIRM_TITLE_6')
    },
    cartToMainPage: {
      type: [String],
      default: BX.message('CART_TO_MAIN_PAGE')
    },
  },
  computed: {
    ...mapGetters('moduleCart', {
      cartItems: 'allItems',
      cntCartItems: 'cntItems'
    }),
    groupedItems: function(){
      let map = this.cartItems.reduce((r, i) => {
        r[i.group] = r[i.group] || [];
        r[i.group].push(i);
        return r;
      }, {});
      return map;
    },
    isFormValid: function(){
      return this.validForm();
    },
  },
  watch: {
    selectedShippingMethod: function(val){
      if(val === 'delivery'){
        this.getCities();
        setTimeout(() => {
          //window.initSlimSelect('.default-select', '.default-select__select');
          window.initCalendar('.input-date');
        }, 100);
      }
    },
    cntCartItems() {
      setTimeout(() => {
        let phoneMask = new Inputmask("+7 (999) 999 - 99 - 99", {placeholder: '+7 (___) ___ - __ - __'});
        let phoneInput = document.querySelector('[data-input-mask="phone"]');
        phoneMask.mask(phoneInput);
      }, 200);
    }
  },
  methods: {
    async orderSend(){
      try {
        let _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ type: 'reachGoal', id: 3352405, goal: 'order'});

        let formData = new FormData();
        formData.append('FIO', this.personalData.fio.value);
        formData.append('EMAIL', this.personalData.email.value);
        formData.append('PHONE', this.personalData.phone.value);
        formData.append('COMPANY_NAME', this.personalData.companyName.value);
        formData.append('COMPANY_SITE', this.personalData.companySite.value);
        formData.append('JOB_TITLE', this.personalData.jobTitle.value);

        if (this.deliveryData.date.value) {
          let date = new Date(this.deliveryData.date.value);
          date = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth()+1)).slice(-2) + '.' + date.getFullYear();

          this.deliveryData.date.value = date;
        }

        if(this.selectedShippingMethod == 'delivery'){
          formData.append('CITY', this.deliveryData.city.value);
          formData.append('STREET', this.deliveryData.street.value);
          formData.append('HOUSE', this.deliveryData.house.value);
          formData.append('DATE', this.deliveryData.date.value);
          formData.append('COMMENT', this.deliveryData.comment.value);
        }
        let response = await fetch("/api/cart/order/", {
          method: "POST",
          body: formData,
        });
        let result = await response.json();
        if (result.success) {
          window.FancyBox.show([{src: '#order-confirm'}], {
            Toolbar: false,
            dragToClose: false,
            Thumbs: false,
            mainClass: 'fullscreen',
            autoFocus: true,
          });

          setTimeout(() => {
            let btn = document.querySelector('#order-confirm button[data-fancybox-close]');

            if (btn !== undefined) {
              btn.addEventListener('click', function(){
                window.location.href = '/cart/';
              });
            }
          }, 100);
        } else {
          alert(result.message);
        }
      } catch (e) {
        alert(e);
      }
    },
    async getCities(inputValue = ''){
      try {
        let formData = new FormData();
        formData.append('q', inputValue);
        let response = await fetch('/api/cart/cities/', {
          method: 'POST',
          body: formData,
        });
        let result = await response.json();
        if (result.success) {
          this.cities = result.data;
        }
      } catch (e) {
        alert(e);
      }
    },
    validForm(){
      let validPersonalDataResult = this.validArrayFields(this.personalData);
      let validDeliveryDataResult = true;
      if(this.selectedShippingMethod === 'delivery'){
        validDeliveryDataResult = this.validArrayFields(this.deliveryData);
      }
      return (validPersonalDataResult && validDeliveryDataResult);
    },
    validArrayFields(arrayFields){
      let result = true;
      for(let key in arrayFields){
        let field = arrayFields[key];
        if(field.pattern){
          if(field.type !== 'checkbox' && !field.pattern.test(field.value)){
            result = false;
          }else if(field.type === 'checkbox' && !field.value){
            result = false;
          }
        }
      }

      return result;
    },
    numWords(value, words){
      value = Math.abs(value) % 100;
      var num = value % 10;
      if(value > 10 && value < 20) return words[2];
      if(num > 1 && num < 5) return words[1];
      if(num === 1) return words[0];
      return words[2];
    },
    deliveryDateCalc(){
      if (this.groupedItems['Индивидуальная упаковка'] !== undefined && this.groupedItems['Индивидуальная упаковка'].length > 0)
        return new Date(new Date().getTime() + (240 * 60 * 60 * 1000)).toISOString().split('T')[0]

      if (this.groupedItems['Готовые решения'] !== undefined && this.groupedItems['Готовые решения'].length > 0)
        return new Date(new Date().getTime() + (168 * 60 * 60 * 1000)).toISOString().split('T')[0]

      if (this.groupedItems['Упаковка в наличии'].length > 0)
        return new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).toISOString().split('T')[0]

      return new Date()
    },
  },
}
</script>